import React, { useState } from "react";
import PropTypes from "prop-types";
import { imagesType } from "../type";
import Slider from "react-slick";
import { ArrowLeft, ArrowRight } from "react-feather";
import i18n from "~/assets/js/Helpers/i18n";

const GalleryMobile = ({ images, backLink }) => {
    const [slideNum, setSlideNum] = useState(1);

    const SliderConfig = {
        speed: 500,
        draggable: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        swipe: false,
        lazyLoad: "progressive",
        nextArrow: <GalleryNextArrow />,
        beforeChange: (_old, newIdx) => setSlideNum(newIdx + 1),
        afterChange: (i) => setSlideNum(i + 1),
    };

    return (
        <div style={{ position: "relative" }}>
            <span className="slide-number">
                {slideNum}/{images.length}
            </span>
            <BackButton backLink={backLink} />
            <Slider {...SliderConfig}>
                {images.map((image, i) => {
                    return <img alt="image" src={image.src} key={i} />;
                })}
            </Slider>
        </div>
    );
};

const GalleryNextArrow = ({ onClick }) => {
    return (
        <div className="arrow-next" onClick={onClick}>
            <ArrowRight size={48} />
        </div>
    );
};

const BackButton = ({ backLink }) => {
    const handleBack = () => {
        if (backLink) {
            return (window.location.href = backLink);
        }
        window.history.back();
    };

    return (
        <div className="goback-button" onClick={handleBack}>
            <ArrowLeft size={22} /> {i18n.t("header.back")}
        </div>
    );
};

BackButton.propTypes = { backLink: PropTypes.string };
GalleryNextArrow.propTypes = { onClick: PropTypes.func };
GalleryMobile.propTypes = imagesType;
export default GalleryMobile;
